import React from 'react';

import TurnedIn from 'material-ui/svg-icons/action/turned-in';
import TurnedInNot from 'material-ui/svg-icons/action/turned-in-not';

import { Edit } from 'components/detail';
import { SimpleForm } from 'components/form';

import { TextInput, MultipleChoicesFromDataInput } from 'components/input';

import {
  DisabledInputOptions,
} from 'util/constants';


export const ShopMenuPreset = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput options={DisabledInputOptions} source="shop_id" label="Shop ID"/>
      <TextInput options={DisabledInputOptions} source="shop_name" label="Shop Name"/>
      <MultipleChoicesFromDataInput
        label="Options"
        source="options"
        choiceSource="option_choices"
        options={{checkedIcon: <TurnedIn />, uncheckedIcon: <TurnedInNot />}}
      />
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/routes/shop/ShopMenuPreset.js